// 1. Importe os componentes do Swiper para React
import { Swiper, SwiperSlide } from 'swiper/react';
// 2. Importe os módulos de Paginação e Navegação (as setinhas e as bolinhas)
import { Navigation, Pagination } from 'swiper/modules';

// 3. Importe os estilos padrões do Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import "../css/GaleriaImagem.css";

function GaleriaImagem() {
  // Cria a lista de 1 a 15 (.png)
  const imageNames = Array.from({ length: 15 }, (_, i) => i + 1).map(num => `${num}.png`);

  return (
    <div className="gallery-container-aprovados">
      {/* 4. Substitua a div externa pelo componente Swiper */}
      <Swiper
        modules={[Navigation, Pagination]} // Ativa os recursos extras
        spaceBetween={20}                  // Espaço de 20px entre as imagens
        slidesPerView={2}                  // Celular: 2 por vez
        breakpoints={{ 768: { slidesPerView: 5 } }} // Computador/tablet: 5 por vez (como antes)
        navigation={true}                  // Adiciona as setinhas de Avançar/Voltar
        pagination={{ clickable: true }}   // Adiciona as bolinhas embaixo de navegação
        loop={true}                        // Faz o carrossel voltar pro início ao terminar
        className="mySwiper"
      >
        {imageNames.map((name, index) => (
          // 5. Cada item do loop DEVE ser um SwiperSlide
          <SwiperSlide key={index}>
            <div className="image-card-aprovados">
              <img src={`assets/images/aprovados/${name}`} alt={`Gallery item ${index}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default GaleriaImagem;